import { StaticTextDataDto } from '@app/data/dtos/static-text/static-text-data-dto';
import { StaticText } from '@app/entities/models/static-text/static-text.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapStaticText: MapFromFn<StaticTextDataDto, StaticText> = (value) =>
  Builder.forModel(StaticText)
    .key(value.static_text?.key)
    .html(value.static_text?.html)
    .section(value.static_text?.section)
    .title(value.static_text?.title)
    .value(value.static_text?.value)
    .build();
